import { render, staticRenderFns } from "./FormMarketingCampaignGeneralInfo.vue?vue&type=template&id=7c53adc4&scoped=true&"
import script from "./FormMarketingCampaignGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./FormMarketingCampaignGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./FormMarketingCampaignGeneralInfo.vue?vue&type=style&index=0&id=7c53adc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c53adc4",
  null
  
)

export default component.exports